var _path, _circle, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.25C14.5 11.4256 11.9256 14 8.75 14V15.5C12.7541 15.5 16 12.2541 16 8.25H14.5ZM8.75 14C5.57436 14 3 11.4256 3 8.25H1.5C1.5 12.2541 4.74594 15.5 8.75 15.5V14ZM3 8.25C3 5.07436 5.57436 2.5 8.75 2.5V1C4.74594 1 1.5 4.24594 1.5 8.25H3ZM8.75 2.5C11.9256 2.5 14.5 5.07436 14.5 8.25H16C16 4.24594 12.7541 1 8.75 1V2.5Z",
    fill: "#2E3438"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.75017,
    cy: 5.8322,
    r: 0.711111,
    fill: "#2E3438"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.03906,
    y: 7.39648,
    width: 1.42222,
    height: 4.55111,
    rx: 0.4,
    fill: "#2E3438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBox);
export default __webpack_public_path__ + "static/media/infoBox.80bc4b0bd4e89af43dbdaa28d2e813fe.svg";
export { ForwardRef as ReactComponent };